import { Controller } from 'stimulus'

export default class extends Controller {

  connect() {
    this.lastScrollY = window.pageYOffset
    this.threshold = window.innerHeight + 200
    this.handleScroll = this.handleScroll.bind(this)

    window.addEventListener('scroll', this.handleScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const currentScrollY = window.pageYOffset

    if (currentScrollY > this.threshold && currentScrollY < this.lastScrollY) {
      this.element.classList.add('fixed')
    } else {
      this.element.classList.remove('fixed')
    }

    this.lastScrollY = currentScrollY
  }
}